(() => {
  function initializeNavigation() {
    const header = document.querySelector("[data-header]");
    if (!header) return;

    const button = header.querySelector("[data-menu-toggle]");
    const panel = header.querySelector("[data-mobile-panel]");

    if (!button || !panel || button.dataset.menuReady === "true") return;
    button.dataset.menuReady = "true";

    function setOpen(open) {
      button.setAttribute("aria-expanded", String(open));
      button.classList.toggle("is-open", open);
      panel.classList.toggle("is-open", open);
      document.body.classList.toggle("menu-open", open);
    }

    button.addEventListener("click", () => {
      setOpen(button.getAttribute("aria-expanded") !== "true");
    });

    panel.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setOpen(false));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setOpen(false);
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 960) setOpen(false);
    });

    function updateShadow() {
      header.style.boxShadow =
        window.scrollY > 14
          ? "0 12px 28px rgba(20, 73, 114, 0.08)"
          : "none";
    }

    updateShadow();
    window.addEventListener("scroll", updateShadow, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeNavigation);
  } else {
    initializeNavigation();
  }

  document.addEventListener("shopify:section:load", initializeNavigation);
})();
